//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProjectActionsContainerSimple from '@/components/Projects/NewProjectSteps/shared/ProjectActionsContainerSimple.vue'
import handleErrorMixin from '@/mixins/handleErrorMixin'
import Button from '~/components/Shared/Button'
import PROJECT_ROLES from '~/constants/project-roles'
import ProjectModalAddUsers from '~/components/Projects/NewProjectSteps/shared/ProjectModalAddUsers.vue'
import InputFile from '~/components/Shared/Form/InputFile.vue'
import ExampleUploadFile from '~/components/Shared/Form/ExampleUploadFile.vue'

export default {
  name: 'MassiveImportUserModal',
  components: {
    Button,
    ProjectActionsContainerSimple,
    ProjectModalAddUsers,
    InputFile,
    ExampleUploadFile,
  },
  mixins: [handleErrorMixin],
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      active: this.value,
      file: null,
      message: null,
    }
  },
  computed: {
    isEnableSubmit() {
      return !!this.file
    },
  },
  watch: {
    value() {
      this.active = this.value
    },
    active(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    reset() {
      this.file = null
    },

    async massValidateUsers({ file, message }) {
      try {
        this.$store.commit('loading', true)
        const formData = new FormData()
        formData.append('massive', file)
        formData.append('message', message)
        formData.append('project_id', this.projectId)
        formData.append('user_origin', 'relink')
        formData.append('project_role', PROJECT_ROLES.SUPERVISOR)
        const response = await this.$repository.invitation.massValidateSupervisors(
          formData
        )
        this.file = null
        this.$emit('massive-users-details', response)
      } catch (e) {
        this.handleError(e, e.response?.data?.error || 'Ocurrió un error')
      } finally {
        this.$store.commit('loading', false)
      }
    },
  },
}
